class Wishlist {
  constructor () {
    this.swatReady = false
    this.eventBus = {
      wishlist_ready: 'WISHLIST_READY',
      wishlist_intent: 'WISHLIST_INTENT',
      wishlist_add: 'WISHLIST_ADD',
      wishlist_added: 'WISHLIST_ADDED',
      wishlist_remove: 'WISHLIST_REMOVE',
      wishlist_removed: 'WISHLIST_REMOVED',
      wishlist_add_product: 'WISHLIST_ADD_PRODUCT',
      wishlist_added_product: 'WISHLIST_ADDED_PRODUCT',
      wishlist_remove_product: 'WISHLIST_REMOVE_PRODUCT',
      wishlist_removed_product: 'WISHLIST_REMOVED_PRODUCT',
      wishlist_populate_shared: 'WISHLIST_POPULATE_SHARED',
      wishlist_rename: 'WISHLIST_RENAME',
      wishlist_renamed: 'WISHLIST_RENAMED',
    }

    this.setupListeners()
    this.initialise()
  }

  setupListeners () {
    window.addEventListener(this.eventBus.wishlist_add, (e) => {
      this.addWishlist(
        e.detail.name,
      )
    })

    window.addEventListener(this.eventBus.wishlist_remove, (e) => {
      this.removeWishlist(
        e.detail.wishlist,
      )
    })

    window.addEventListener(this.eventBus.wishlist_add_product, (e) => {
      this.addProduct(
        e.detail.wishlistId,
        e.detail.variantId,
        e.detail.productId,
        e.detail.productUrl,
      )
    })

    window.addEventListener(this.eventBus.wishlist_remove_product, (e) => {
      this.removeProduct(
        e.detail.wishlistId,
        e.detail.variantId,
        e.detail.productId,
        e.detail.productUrl,
      )
    })

    window.addEventListener(this.eventBus.wishlist_rename, (e) => {
      this.renameWishlist(
        e.detail.wishlist,
        e.detail.newName,
      )
    })

    const headerCountEventList = [
      this.eventBus.wishlist_added,
      this.eventBus.wishlist_removed,
      this.eventBus.wishlist_added_product,
      this.eventBus.wishlist_removed_product,
    ]
    headerCountEventList.forEach((event) => {
      window.addEventListener(event, () => {
        this.handleHeader()
      })
    })
  }

  initialise () {
    this.handleHeader()
  }

  async addWishlist (wishlistName) {
    if (!this.swatReady) {
      await this.checkSwatReady()
    }

    const listConfig = {
      lname: wishlistName,
      lprops: {
        customerId: window.theme.customer.id,
      },
    }
    const event = new CustomEvent(this.eventBus.wishlist_added, {
      detail: {
        wishlist: wishlistName,
      },
    })
    const onSuccess = function (list) {
      window.dispatchEvent(event)

      // console.info('addWishlist() - Success', list)
    }
    const onError = function (errorMessage) {
      console.error('addWishlist() - Error', errorMessage)
    }

    window._swat.createList(
      listConfig,
      onSuccess,
      onError,
    )
  }

  async removeWishlist (wishlistId) {
    if (!this.swatReady) {
      await this.checkSwatReady()
    }

    const event = new CustomEvent(this.eventBus.wishlist_removed, {
      detail: {
        wishlist: wishlistId,
      },
    })
    const onSuccess = function (list) {
      window.dispatchEvent(event)

      // console.info('removeWishlist() - Success', list)
    }
    const onError = function (errorMessage) {
      console.error('removeWishlist() - Error', errorMessage)
    }

    window._swat.deleteList(wishlistId, onSuccess, onError)
  }

  async addProduct (wishlistId, variantId, productId, productUrl) {
    if (!this.swatReady) {
      await this.checkSwatReady()
    }

    const event = new CustomEvent(this.eventBus.wishlist_added_product, {
      detail: {
        variantId,
        productId,
        productUrl,
      },
    })
    const product = {
      epi: variantId,
      empi: productId,
      du: productUrl,
    }
    const onSuccess = function (item) {
      window.dispatchEvent(event)

      // console.info('addProduct() - Success', item)
    }
    const onError = function (errorMessage) {
      console.error('addProduct() - Error', errorMessage)
    }

    window._swat.addToList(
      wishlistId,
      product,
      onSuccess,
      onError,
    )
  }

  async removeProduct (wishlistId, variantId, productId, productUrl) {
    if (!this.swatReady) {
      await this.checkSwatReady()
    }

    const product = {
      epi: variantId,
      empi: productId,
      du: productUrl,
    }
    const event = new CustomEvent(this.eventBus.wishlist_removed_product, {
      detail: {
        productId,
        variantId,
      },
    })
    const onSuccess = function (item) {
      window.dispatchEvent(event)

      // console.info('removeProduct() - Success', item)
    }
    const onError = function (error) {
      console.error('removeProduct() - Error', error)
    }

    window._swat.deleteFromList(
      wishlistId,
      product,
      onSuccess,
      onError,
    )
  }

  async handleHeader () {
    if (!this.swatReady) {
      await this.checkSwatReady()
    }

    const buttonEl = document.querySelector('[data-wishlist-el="headerButton"]')
    const countEl = document.querySelector('[data-wishlist-el="headerCount"]')

    if (!countEl || !buttonEl) return

    const onSuccess = function (wishlists) {
      let count = wishlists.reduce((acc, wishlist) => {
        return acc + wishlist.listcontents.length
      }, 0)

      if (count > 99) {
        count = '99+'
      }

      if (count > 0) {
        countEl.textContent = count
        buttonEl.setAttribute('data-wishlist-isempty', false)
      } else {
        countEl.textContent = ''
        buttonEl.setAttribute('data-wishlist-isempty', true)
      }

      buttonEl.setAttribute('aria-hidden', false)

      // console.info('handleHeader() - Success', wishlists)
    }
    const onError = function (error) {
      console.error('handleHeader() - Error', error)
    }

    window._swat.fetchLists({
      callbackFn: onSuccess,
      errorFn: onError,
    })
  }

  async renameWishlist (wishlistId, newName) {
    if (!this.swatReady) {
      await this.checkSwatReady()
    }

    const listUpdateConfig = {
      lid: wishlistId,
      lname: newName,
    }

    const event = new CustomEvent(this.eventBus.wishlist_renamed, {
      detail: {
        wishlistId,
      },
    })

    const onSuccess = function () {
      window.dispatchEvent(event)
    }

    const onError = function (error) {
      console.error('renameWishlist() - Error', error)
    }

    window._swat.updateList(
      listUpdateConfig,
      onSuccess,
      onError,
    )
  }

  checkSwatReady () {
    return new Promise((resolve) => {
      const intervalId = setInterval(() => {
        if (!window._swat) return

        clearInterval(intervalId)

        this.swatReady = true

        const event = new CustomEvent(this.eventBus.wishlist_ready)
        window.dispatchEvent(event)

        resolve(true)
      }, 200)
    })
  }
}

window.theme.wishlist = new Wishlist()
